<div class="e-sku-data-layout">
    <mat-tab-group animationDuration="0ms" class="e-nested-tabs" role="tabpanel">
        <mat-tab label="Price history">

        </mat-tab>
        <mat-tab label="Promotions summary">

        </mat-tab>
        <mat-tab label="Daily promotions">

        </mat-tab>
        <mat-tab label="Availability summary">

        </mat-tab>
        <mat-tab label="Daily availability">

        </mat-tab>
        <mat-tab label="Average ratings">

        </mat-tab>
    </mat-tab-group>
</div>
